/* Piedras del zodiaco: cuadrícula con la imagen de cada piedra (Piedra 1 = gota, Piedra 2 = rectangular) */
window.cmGemImg = function (n, i) {
  var m = window.CM_MESES[i].split(' · ')[0].toLowerCase();
  return window.CM_GEM_BASE.replace('cm-piedra1-enero', 'cm-piedra' + n + '-' + m) + '?width=120';
};
window.cmStoneModal = window.cmStoneModal || (function () {
  var el = null, sel = [], done = null, keys = [];
  function grid(n) {
    var h = '<div class="cm-st-sec"><div class="cm-st-h"><b>PIEDRA ' + n + '</b> · Elige el mes</div><div class="cm-st-grid">';
    window.CM_MESES.forEach(function (full, i) {
      h += '<button type="button" class="cm-st-gem" data-n="' + n + '" data-i="' + i + '"><img src="' + window.cmGemImg(n, i) + '" alt="' + full + '" width="40" height="40"><span>' + full.split(' · ')[0] + '</span></button>';
    });
    return h + '</div></div>';
  }
  function paint() {
    el.querySelectorAll('.cm-st-gem').forEach(function (b) {
      b.classList.toggle('cm-on', sel[+b.dataset.n - 1] === +b.dataset.i);
    });
    var c = sel.filter(function (x) { return x !== null && x !== undefined; }).length;
    el.querySelector('.cm-st-count').textContent = c + '/2';
    el.querySelector('.cm-st-ok-n').textContent = c + '/2';
    el.querySelector('.cm-st-ok').classList.toggle('cm-ready', c === 2);
    el.querySelector('.cm-st-msg').hidden = true;
  }
  function build() {
    el = document.createElement('div');
    el.className = 'cm-st-ov';
    el.innerHTML = '<div class="cm-st-dlg" role="dialog" aria-modal="true">' +
      '<div class="cm-st-top"><div class="cm-st-ttl">Elige las piedras <span class="cm-st-count">0/2</span></div><button type="button" class="cm-st-x" aria-label="Cerrar">&times;</button></div>' +
      '<div class="cm-st-body"><div class="cm-st-prev"><img alt="Anillo Piedra del Zodiaco" width="300" height="300"></div>' +
      grid(1) + grid(2) + '</div>' +
      '<div class="cm-st-foot"><div class="cm-st-msg" hidden>Elige la piedra 1 y la piedra 2.</div><button type="button" class="cm-st-ok"><span>CONFIRMAR</span><span class="cm-st-ok-n">0/2</span></button></div></div>';
    document.body.appendChild(el);
    el.querySelector('.cm-st-prev img').src = window.CM_ZOD_IMG;
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('.cm-st-x')) { close(); return; }
      var g = e.target.closest('.cm-st-gem');
      if (g) { sel[+g.dataset.n - 1] = +g.dataset.i; paint(); return; }
      if (e.target.closest('.cm-st-ok')) {
        if (sel[0] == null || sel[1] == null) { el.querySelector('.cm-st-msg').hidden = false; return; }
        if (done) done(sel.slice());
        close();
      }
    });
  }
  function close() { el.classList.remove('cm-open'); document.documentElement.classList.remove('cm-st-lock'); }
  return function open(current, title, cb) {
    if (!el) build();
    sel = current.slice(); done = cb;
    el.querySelector('.cm-st-ttl').firstChild.nodeValue = 'Elige las piedras' + (title ? ' · ' + title : '') + ' ';
    paint();
    el.querySelector('.cm-st-body').scrollTop = 0;
    el.classList.add('cm-open');
    document.documentElement.classList.add('cm-st-lock');
  };
})();
window.cmStonesRender = function (box, cfg, compact) {
  var html = '<button type="button" class="cm-st-open"><span class="cm-st-open-t">ELIGE TUS PIEDRAS</span><span class="cm-st-open-s">Piedra 1 y piedra 2 · 0/2</span><span class="cm-st-open-p">+</span></button>';
  html += '<div class="cm-st-picked" hidden></div>';
  cfg.campos.forEach(function (c) { html += '<input type="hidden" class="cm-perso-input" data-k="' + c.k + '" value="">'; });
  html += '<div class="cm-perso-error" hidden></div>';
  box.innerHTML = html;
  box.classList.add('cm-perso');
  var sel = [null, null];
  var inputs = box.querySelectorAll('input.cm-perso-input');
  function show() {
    var c = sel.filter(function (x) { return x !== null; }).length;
    box.querySelector('.cm-st-open-s').textContent = c === 2 ? 'Cambiar piedras · 2/2' : 'Piedra 1 y piedra 2 · ' + c + '/2';
    var p = box.querySelector('.cm-st-picked');
    if (c === 2) {
      p.innerHTML = [0, 1].map(function (k) {
        return '<span class="cm-st-pk"><img src="' + window.cmGemImg(k + 1, sel[k]) + '" alt="" width="22" height="22">Piedra ' + (k + 1) + ': ' + window.CM_MESES[sel[k]].split(' · ')[0] + '</span>';
      }).join('');
      p.hidden = false;
    } else { p.hidden = true; }
  }
  box.querySelector('.cm-st-open').addEventListener('click', function () {
    window.cmStoneModal(sel, '', function (s) {
      sel = s;
      inputs[0].value = window.CM_MESES[s[0]];
      inputs[1].value = window.CM_MESES[s[1]];
      box.classList.remove('cm-perso-bad');
      box.querySelector('.cm-perso-error').hidden = true;
      show();
    });
  });
  return function read(silent) {
    var props = {};
    if (sel[0] === null || sel[1] === null) {
      if (!silent) {
        var err = box.querySelector('.cm-perso-error');
        err.textContent = 'Elige tus piedras: piedra 1 y piedra 2.';
        err.hidden = false;
        box.classList.add('cm-perso-bad');
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return null;
    }
    inputs.forEach(function (inp) { props[inp.dataset.k] = inp.value; });
    return props;
  };
};
